<template>
  <v-app>
    <AnalyticsTracker />
    <Loading />

    <StructureBrowser v-if="$store.state.structures.show && !isLoading" />
    <NotificationDesktop />
    <FeedbackForm />
    <OpenAIDesktop />
    <Preview />
    <Ideas />
    <MediaDesktop />
    <AgentComp v-if="!isLoading && $route.path === '/post'" />
    <PostBottomSheet />
    <CategoryBottomSheet />
    <NavigationDrawer />
    <!-- <AppBar
      @queue_drawer="queue_drawer = true"
      v-if="
        !$route.meta.noNav &&
        !$vuetify.display.smAndDown &&
        !$route.meta.noHeader
      "
    /> -->

    <v-main
      v-if="!$vuetify.display.smAndDown || $route.path === '/waiting-list'"
    >
      <router-view v-slot="{ Component }">
        <transition name="slide-fade" mode="out-in">
          <component
            :class="{
              mobile:
                $vuetify.display.smAndDown &&
                $route.path != '/inbox' &&
                $route.path != '/access' &&
                $route.path != '/verify' &&
                $route.path != '/reset',
              desktop:
                !$vuetify.display.smAndDown &&
                $route.path != '/access' &&
                $route.path != '/waiting-list' &&
                $route.path != '/calendar' &&
                $route.path != '/post' &&
                $route.path != '/feed' &&
                $route.path != '/chat' &&
                $route.path != '/join' &&
                $route.path != '/create-workspace' &&
                $route.path != '/verify' &&
                $route.path != '/reset' &&
                !$route.path.includes('/library') &&
                !$route.path.includes('/settings') &&
                !$route.path.includes('/admin'),
            }"
            :is="Component"
          />
        </transition>
      </router-view>
    </v-main>
    <div v-else class="pa-6 bg-primary" style="height: 100vh">
      <v-img
        contain
        width="35"
        class="mb-8"
        :src="require('@/assets/logo/logo-white.svg')"
        alt=""
      />
      <p class="text-white">
        Stix is optimized to be used on a computer. Please come back when you're
        on a computer!
      </p>
    </div>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import "animate.css";
import FeedbackForm from "@/components/FeedbackForm.vue";
import NavigationDrawer from "@/components/NavigationDrawer.vue";
import NotificationDesktop from "@/components/notifications/NotificationDesktop.vue";
import OpenAIDesktop from "@/components/openai/OpenaiDesktop.vue";
// import Queue from "@/components/queue/DrawerDesktop.vue";
import Preview from "@/components/preview/PreviewDialog.vue";
import Ideas from "@/components/IdeasDrawer.vue";
import Loading from "@/components/LoadingCard.vue";
import MediaDesktop from "@/components/media/BrowserDesktop.vue";
import StructureBrowser from "@/components/structures/structuresBrowser.vue";
import AnalyticsTracker from "@/components/Analytics.vue";
import AgentComp from "@/components/agent/AgentComp.vue";
import PostBottomSheet from "@/components/post/PostBottomSheet.vue";
import CategoryBottomSheet from "@/components/category/CategoryBottomSheet.vue";
export default {
  name: "App",
  components: {
    StructureBrowser,
    MediaDesktop,
    Preview,
    NavigationDrawer,
    FeedbackForm,
    NotificationDesktop,
    OpenAIDesktop,
    Ideas,
    Loading,
    AnalyticsTracker,
    AgentComp,
    PostBottomSheet,
    CategoryBottomSheet,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      isLoading: (state) => state.loading.general,
    }),
  },
  data: () => ({
    drawer: false,
    queue_drawer: false,
    user_id: null,
    access_token: "",
  }),
  methods: {
    logout() {
      window.FB.logout(function (response) {
        console.log(response);
      });
    },
    async page_token() {
      const page_token = httpsCallable(functions, "page_token");
      const res = await page_token({
        id: this.$store.state.social.user_id,
        access_token: this.$store.state.social.access_token,
      });
      this.$store.commit("setPageTokens", res.data.data);
    },
    async post() {
      const post = httpsCallable(functions, "post");
      const res = await post({
        message: "this is a test",
        method: "POST",
        page_id: "264654333561511",
        access_token: this.$store.state.social.page_tokens[0].access_token,
      });

      console.log(res.data);
    },
    async status() {
      window.FB.getLoginStatus(function (response) {
        if (response.status === "connected") {
          console.log(response.authResponse);
        }
      });
    },
    test() {
      const vm = this;
      window.FB.login(
        function (response) {
          if (response.authResponse) {
            vm.$store.commit("setUserId", response.authResponse.userID);
            vm.$store.commit(
              "setAccessToken",
              response.authResponse.accessToken
            );

            console.log("Welcome!  Fetching your information.... ");
            window.FB.api("/me", function (response) {
              console.log("Good to see you, " + response.name + ".");
            });
            window.FB.api("/me/permissions", function (response) {
              console.log(JSON.stringify(response));
            });
          } else {
            console.log("User cancelled login or did not fully authorize.");
          }
        },
        { scope: "public_profile,email" }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.animate__animated.animate__slideInDown {
  --animate-duration: 0.5s;
}
.animate__animated.animate__slideInLeft {
  --animate-duration: 0.5s;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
  transition-delay: 0.2s;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.desktop {
  padding: 20px 44px 0 44px;
  max-width: 1800px;
}
.mobile {
  padding: 30px 44px;
  margin: 0 auto;
}
</style>

<style lang="scss">
.v-input--switch__thumb {
  border-bottom: 2px solid #272727;
  border-left: 1px solid #272727;
  border-top: 1px solid #272727;
  border-right: 2px solid #272727;
}

.v-menu__content {
  border-bottom: 3px solid #272727;
  border-left: 1px solid #272727;
  border-top: 1px solid #272727;
  border-right: 3px solid #272727;
  border-radius: 6px;
}

.myClass:focus::before {
  opacity: 0 !important;
}
</style>
